import createVueApp from '@phoenix/createVueApp';

import PhxsgVariationsList from './phxsg-variations-list.vue';

document.querySelectorAll('.phxsg-variations-list-container').forEach((el) => {
  const app = createVueApp();
  app.component('PhxsgVariationsList', PhxsgVariationsList);
  app.mount(el);
});
